import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Clock, RefreshCw, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const PagamentoPendentePage = () => {
  const [searchParams] = useSearchParams();
  const participanteId = searchParams.get('ref') || searchParams.get('external_reference');

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center p-4" data-testid="pagamento-pendente-page">
      <div className="max-w-lg w-full text-center">
        {/* Pending Icon */}
        <div className="w-24 h-24 mx-auto mb-8 rounded-full bg-yellow-500/20 flex items-center justify-center">
          <Clock className="w-12 h-12 text-yellow-500 animate-pulse" />
        </div>

        <h1 className="font-display text-3xl md:text-4xl text-white mb-4">
          Pagamento em Processamento
        </h1>

        <p className="text-gray-400 text-lg mb-8">
          Seu pagamento está sendo processado. Assim que for confirmado, você receberá um e-mail e seu acesso será liberado automaticamente.
        </p>

        <div className="bg-white/5 border border-white/10 rounded-xl p-6 mb-8">
          <h3 className="text-white font-semibold mb-4">O que acontece agora?</h3>
          <ul className="text-left text-gray-400 space-y-3">
            <li className="flex items-start gap-3">
              <span className="text-yellow-500 mt-1">•</span>
              <span>Se você escolheu <strong className="text-white">PIX</strong>, aguarde a confirmação (geralmente instantânea)</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-yellow-500 mt-1">•</span>
              <span>Se você escolheu <strong className="text-white">Boleto</strong>, aguarde a compensação (1-3 dias úteis)</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-yellow-500 mt-1">•</span>
              <span>Se você escolheu <strong className="text-white">Cartão</strong>, a confirmação é quase instantânea</span>
            </li>
          </ul>
        </div>

        <div className="space-y-4">
          <p className="text-gray-500 text-sm">
            Você receberá um e-mail assim que o pagamento for confirmado.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={() => window.location.reload()} 
              className="bg-gray-800 hover:bg-gray-700 text-white px-8"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Verificar Status
            </Button>
            
            <Link to="/">
              <Button variant="outline" className="border-white/20 text-gray-300 hover:bg-white/5">
                Voltar ao Início
              </Button>
            </Link>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-gray-500 text-sm">
            Dúvidas? Entre em contato pelo WhatsApp: (69) 99999-9999
          </p>
        </div>
      </div>
    </div>
  );
};

export default PagamentoPendentePage;
